import * as React from 'react';
import Zoom from '../image-zoom';
import classnames from 'classnames';
import { isNode } from '../../../utils/micro-utils';
import * as webp from '@alife/bc-webp';
import { getZoomSize } from '../adopt';
import { IMAGE_WIDTH, IMAGE_HEIGHT, DEFAULT_404_PHOTO } from '../constant';

interface OtherProps {
  onItemClick?: (event: React.MouseEvent<HTMLElement>) => void;
  className?: string;
  imageSize?: 'big' | 'normal' | 'thumb';
  zoom: boolean;
  isCurrent: boolean;
  imageHeight?: number;
  style?: any;
}
export default class Image extends React.Component<
  PcMainImage.ImageData & OtherProps
> {
  state = {
    x: 0,
    y: 0,
  };

  /**
   * 因为图片的尺寸过小，会导致zoom的时候出问题，所以这里将图片url中的裁剪参数给去掉
   */
  handleZoomImage(url = '') {
    return url.replace(/\.(jpg|jpeg|png)_(\d+)x\d+\.\1/gi, (all, g1, g2) => {
      if (g2 && Number(g2) > 400) return all;

      return `.${g1}`;
    });
  }

  moveImage = e => {
    const { x, y } = this.state;
    e.preventDefault();

    const disx = e.pageX - x;
    const disy = e.pageY - y;

    document.onmousemove = (ev: any) => {
      this.setState({
        x: ev.pageX - disx,
        y: ev.pageY - disy,
      });
    };

    document.onmouseup = () => {
      document.onmousemove = null;
      document.onmousedown = null;
    };
  };

  render() {
    const { imageUrl, imageSize } = this.props;
    if (this.props.zoom) {
      // 防止闪烁，不适用 @alife/bc-webp
      let imageToShow = imageUrl[imageSize || 'big'];
      if (isNode() && imageUrl.thumb) {
        imageToShow = imageUrl.thumb;
        return (
          <img
            src={imageToShow}
            style={{
              height: IMAGE_HEIGHT,
              width: IMAGE_WIDTH,
            }}
            alt="mainCover"
          />
        );
      }

      if (!imageToShow) {
        return (
          <img
            src={DEFAULT_404_PHOTO}
            alt="404"
            style={{
              width: IMAGE_WIDTH,
              height: IMAGE_HEIGHT,
            }}
          />
        );
      }

      return (
        <Zoom
          width={IMAGE_WIDTH}
          height={IMAGE_HEIGHT}
          img={this.handleZoomImage(imageToShow)}
          handleClick={this.props.onItemClick}
          zoomWidth={getZoomSize().width}
          zoomStyle={`box-shadow: 0px 0px 2px 1px #999;transform: translateX(103%);height: ${
            getZoomSize().width
          }px;background-color: #FFF;`}
          zoomLensStyle="background: rgba(255,106,0,0.20);
        border: 1px solid #FF6A00;"
        />
      );
    }

    let thumbUrl = imageUrl[imageSize || 'big'];
    if (!thumbUrl) return null;

    // 因为Big的图片仍然会带有裁剪参数，影响展示的清晰度，这里强制去掉
    if (imageSize === 'big') {
      thumbUrl = this.handleZoomImage(thumbUrl);
    }

    return (
      <img
        src={thumbUrl}
        alt="image"
        onClick={this.props.onItemClick}
        onMouseDown={this.moveImage}
        className={classnames(this.props.className, 'J-slider-cover-item')}
        style={{
          ...this.props.style,
          height: this.props.imageHeight,
          cursor: 'move',
          transform:
            this.props.style &&
            `${this.props.style.transform} translate(${this.state.x}px, ${this.state.y}px)`,
        }}
      />
    );
  }
}
